import { Injectable, isDevMode } from '@angular/core';
import { environment } from "@environments/environment";
import { HttpClient, provideHttpClient } from "@angular/common/http";
import { provideTransloco, Translation, TranslocoLoader, TranslocoService } from "@jsverse/transloco";


/**
 * https://jsverse.github.io/transloco/docs/getting-started/installation
 * */
@Injectable({ providedIn: 'root' })
export class TransLocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {
  }

  public getTranslation(lang: string) {
    /** 
     * Loader tự động nhận diện tiền tố assets từ môi trường (assetsPrefix). 
     * Giúp hệ thống luôn tìm đúng file i18n dù đang chạy standalone hay nhúng vào CRM.
     */
    return this.http.get<Translation>(`${environment.assetsPrefix}assets/i18n/${lang}.json`);
  }
}

export const TransLocoProviders: any[] = [
  TranslocoService,
  provideHttpClient(),
  provideTransloco({
    config: {
      availableLangs: environment.language.availableLangs,
      defaultLang: environment.language.code,
      reRenderOnLangChange: true,
      prodMode: !isDevMode(),
    },
    loader: TransLocoHttpLoader,
  }),
]

